import CostCenterAllComponent from './cost_center.all.component';

let CostCenterAllModule = angular.module('costCenterAll', [])
    .component('costCenterAll', CostCenterAllComponent)
    .name;

export default CostCenterAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/all/index.js